// 2020-06-27export { ConsumoChartComponent } from './consumo-chart.component';